import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=01014cae"
import script from "./Crear.vue?vue&type=script&lang=js"
export * from "./Crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01014cae')) {
      api.createRecord('01014cae', component.options)
    } else {
      api.reload('01014cae', component.options)
    }
    module.hot.accept("./Crear.vue?vue&type=template&id=01014cae", function () {
      api.rerender('01014cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/aspectos/Crear.vue"
export default component.exports